import React from "react";
import { IWhatsNext } from "../../src/interfaces";
import WhatsNextCard from "./CallToAction/WhatsNextCard";

interface WhatsNextProps {
  title: string;
  data: IWhatsNext[];
}

function WhatsNext({ title, data }: WhatsNextProps) {
  if (data.length === 0) return null;

  return (
    <div className="flex flex-row justify-center w-full overflow-hidden bg-black">
      <div className="relative xl:px-[95px] pt-2 pb-[114px] flex lg:flex-row flex-col justify-between items-center z-0 mt-28 max-w-[1440px] w-full text-white">
        <div className="flex flex-col w-full md:px-4">
          <div
            id="WhatsNext"
            className="display-5 md:text-display-4 text-center px-4 mx-auto mb-24 uppercase"
          >
            {title}
          </div>
          <div className="hidden md:flex w-full flex-wrap gap-5 justify-center">
            {data.map((whatsNext) => (
              <WhatsNextCard key={whatsNext.title} data={whatsNext} />
            ))}
          </div>
          <div className="flex md:hidden w-full gap-5 px-4 overflow-x-auto no-scrollbar">
            {data.map((whatsNext) => (
              <WhatsNextCard key={whatsNext.title} data={whatsNext} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhatsNext;
